import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'nonprofit-claim',
		path: '/nonprofit/claim/:step',
		component: loadable(async () => import(/* webpackChunkName: "pages/nonprofit_claim" */ './index'), {
			exportName: 'NonprofitClaim',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
		},
		ssr: {
			enabled: false,
			seo: false,
		},
		disableFullRerenderForParams: ['step'],
	},
];
